import React from 'react'
import raiseHand from '../../../../images/ready-module/raiseHand.png'

export default function RaiseHand() {
  return (
    <div className="instruction-image"><img src={raiseHand} alt=""/></div>
  )
}
